import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class FieldsetService extends ApiService {
  namespace = "field-set";
  icon = "Application";
  name = "Custome Fields";
  favicon = "ApplicationForm";
  window = 290;
  Width = 690;
  DOMAIN = DOMAIN.FIELD_SET;
  action = "action";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;

  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: "Label",
      icon: AppIcons.TAG,
      field: "number",
    },
    {
      header: "Fieldset",
      icon: AppIcons.APPLICATION_FORM,
      field: "number",
    },
    {
      header: "Date",
      icon: AppIcons.CALENDAR,
      field: "number",
      width: 8,
    },
  ];

  gemMenuItems = [
    {
      key: "create",
      label: "Create Fieldset",
      icon: AppIcons.LIST,
      services: -3,
    },
    {
      key: "create",
      label: "Create Field",
      icon: AppIcons.LIST,
    },
  ];
  filterItems = [{ name: "FieldSet", key: "field", value: "2", realm: "2" }];
  constructor() {
    super("fieldset");
  }
}
